import { useEffect, useState, useRef, useCallback } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";

import { usePageMetadata } from '../../hooks/usePageMetadata';
import styles from "./Tradies.module.css"
import tradies_nb from "../../assets/images/tradies_nb.svg";
import mylo_home_banner from "../../assets/images/mylo_home_banner_red.svg";
import mylo_home_banner_short from "../../assets/images/mylo_home_banner_short.svg";

import mylo_tradies_white_orange from "../../assets/images/mylo_tradies_white_orange.svg";
import team_banner from "../../assets/images/team_banner.jpg";
import technology from "../../assets/images/technology.png";
import smoke_alarm from "../../assets/images/smoke_alarm.jpg";
import cloud1 from "../../assets/images/cloud1_black.svg";
import cloud2 from "../../assets/images/cloud2_black.svg";
import cloud3 from "../../assets/images/cloud3_black.svg";
import car1 from "../../assets/images/car1_black.svg";
import car2 from "../../assets/images/car2_black.svg";

import Footer from "../Footer"
import Topbar from "../Topbar"


const Banner = () => {
	return (
		<div className={styles.banner_container}>
			<div className={styles.banner_inner_container}>
				<div className={styles.banner_inner}>
					<img src={mylo_tradies_white_orange}/>

					<div className={styles.banner_heading}>
						<h1 className={`xl3 forma bold ${styles.optimised}`}>Trusted MYLO tradies, ready for all jobs big or small.</h1>
						<h1 className={`xxxxxxl3 forma bold ${styles.non_optimised}`}>Trusted MYLO tradies, ready for all jobs big or small.</h1>

						<a className={styles.banner_button} href={"tel:+136956"}>
							<p className={`xl1 inter medium`}>Book an Inspection</p>
							<i className="fa-solid fa-calendar-days xl2"></i>
						</a>
					</div>
				</div>

				<div className={styles.transition_container} style={{ bottom: '-80px' }}>
					<div className={styles.transition_effect_1} style={{ bottom: '50px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#f56329" }}/>
					<div className={styles.transition_effect_2} style={{ bottom: '20px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#f56329" }}/>
					<div className={styles.transition_effect_3} style={{ bottom: '-10px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#f56329" }}/>
				</div>
			</div>
		</div>
	)
}

const ServiceMessage = () => {
	return (
		<div className={styles.cmessage_container}>
			<p className={`xxxxl3 forma bold ${styles.cmessage_banner}`}>Look after your property, and it will look after you.</p>
			<p className={`m2 inter light`}>MYLO Tradies services are designed to take the hassle out of everyday property maintenance. Whether it’s a quick fix, ongoing upkeep, or a bigger repair job, our trusted team of skilled tradespeople delivers reliable, high-quality work with minimal disruption. We understand the pressures property managers and owners face, which is why we focus on clear communication and prompt scheduling, leading to consistent results and lower fees. With a single point of contact and a dependable crew on hand, MYLO makes it easy to keep properties well-maintained, compliant, and tenant-ready—saving time, reducing stress, and ensuring nothing gets overlooked.</p>
		</div>
	)
}

const BannerImage = () => {
	return (
		<div className={styles.bannerimg_wrapper}>
			<div className={styles.bannerimg_container}/>
			<p className={`xxxxxl3 forma bold ${styles.bannerimg_banner}`}>Your trusted partner in property safety,<br/>servicing homes and rentals across Victoria</p>
		</div>
	)
}

const HouseTransition = () => {
	return (
		<div className={styles.house_transition_wrapper}>
			<div className={styles.house_transition_circle}>
				<img src={tradies_nb}/>
			</div>
		</div>
	)
}

const Services = () => {
	const [activeService, setActiveService] = useState("Plumbing")
	const services = {
		"Plumbing": (
			<div className={styles.service_content}>
				<p className={`m2 inter light ${styles.service_content_subheading}`}>Mylo is a reputable and trusted name in the plumbing industry, delivering high-quality plumbing solutions to customers across Australia. Backed by a team of highly skilled and experienced plumbers, we are dedicated to providing exceptional service and addressing all your plumbing needs with efficiency and care.</p>
				<p className={`m2 inter light`}>At Mylo, we offer a comprehensive range of plumbing services to meet the diverse needs of our customers. Our services include:</p>

				<div className={styles.service_arrow_list}>
					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Residential Plumbing: From basic repairs to full system upgrades, we cover all aspects of residential plumbing. Whether it's a leaky faucet, clogged drain, or a complete bathroom renovation, our skilled plumbers have the expertise to get the job done efficiently and reliably.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Commercial Plumbing: We understand the unique demands of commercial plumbing. Our team is experienced in handling projects for offices, restaurants, retail stores, and other commercial properties. We work efficiently to minimise disruption to your business while delivering high-quality plumbing solutions.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Emergency Plumbing: Plumbing emergencies can strike at any time—which is why we offer priority emergency plumbing services. Whether it's a burst pipe, sewer line backup, or water heater failure, our team is ready to respond promptly and resolve the issue.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Plumbing Inspections: Our thorough plumbing inspections are designed to identify potential issues before they become mostly problems. We conduct detailed assessments and provide clear recommendations for repairs or upgrades, ensuring your system performs at its best and lasts longer.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Blocked Drains: We specialise in clearing blocked drains, no matter the cause—whether it's waste build-up or invasive tree roots. Using the latest technology and tools, our experienced plumbers can resolve anything from simple blockages to more complex drainage issues, restoring proper flow and function.</p>
					</div>
				</div>
			</div>
		),
		"Electrical": (
			<div className={styles.service_content}>
				<p className={`m2 inter light ${styles.service_content_subheading}`}>Mylo is a trusted provider of high-quality electrical services across Australia. Founded with a commitment to delivering safe, reliable, and professional solutions, we’ve earned a strong reputation for excellence. Our team of licensed and experienced electricians is equipped to handle electrical projects of all sizes—efficiently and effectively.</p>
				<p className={`m2 inter light`}>At Mylo, we offer a comprehensive range of residential and commercial electrical services to meet the diverse needs of our clients. Our services include:</p>

				<div className={styles.service_arrow_list}>
					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Electrical Installations: Our qualified electricians are skilled in all types of electrical installations, including lighting, switchboards, power points, ceiling fans, and more. We ensure every installation meets safety standards and client expectations.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Electrical Repairs: We know that electrical issues can be disruptive. Our team offers fast and efficient repair services to resolve problems such as faulty wiring, blown fuses, and malfunctioning appliances— restoring safety and functionality to your property.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Electrical Maintenance: Regular maintenance is essential to keep your electrical systems running smoothly and safely. We provide thorough maintenance solutions designed to reduce the risk of unexpected failures and extend the life of your electrical infrastructure.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Electrical Inspections: Our electricians conduct detailed inspections for homes and commercial properties to identify potential hazards and ensure compliance with safety standards. You'll receive a full report with recommendations for any necessary repairs or upgrades.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Emergency Electrical Services: Electrical emergencies can happen without warning. That’s why we offer responsive, priority emergency services to address urgent issues promptly and safely—minimising risk and downtime.</p>
					</div>
				</div>
			</div>
		),
		"Handyman": (
			<div className={styles.service_content}>
				<p className={`m2 inter light ${styles.service_content_subheading}`}>Mylo is a trusted provider of professional handyman services across Australia. As a well-established business, we take pride in delivering high-quality, reliable solutions tailored to the diverse needs of both residential and commercial clients. Our team of experienced and skilled handymen is dedicated to helping you with everything from routine maintenance to property improvements—efficiently and with great attention to detail.</p>
				<p className={`m2 inter light`}>At Mylo, we offer a wide range of handyman services to support your property needs, including:</p>

				<div className={styles.service_arrow_list}>
					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>General Repairs & Maintenance: Our handymen are equipped to handle a variety of repair and maintenance tasks around your property. From fixing leaky faucets and broken doors to installing shelves or hanging picture frames—we’ve got you covered.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Painting & Decorating: Looking to refresh your home or office? We provide professional painting and decorating services, including wall painting and wallpaper installation. We focus on precision and detail to ensure a flawless, long-lasting finish.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Carpentry & Woodwork: Our skilled carpenters can take on a range of woodwork projects, including custom shelving, cabinet installations, furniture repairs, and more. Expect high-quality craftsmanship and attention to detail in every job.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Plumbing Services: We handle basic plumbing tasks such as fixing leaks, clearing blocked drains, and installing taps or fixtures. Our goal is to keep your plumbing systems working efficiently and prevent future issues.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Electrical Services: Electrical emergencies can happen without warning. That’s why we offer responsive, priority emergency services to address urgent issues promptly and safely—minimising risk and downtime.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Assembly & Installation: If you’ve purchased flat-pack furniture, appliances, or equipment, we can take care of the assembly and installation. Our team has the tools and experience to get it done right, saving you time and hassle.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Outdoor Services: We also support outdoor projects such as fence repairs, deck maintenance, gutter cleaning, and basic landscaping. Let us help keep your exterior spaces functional, safe, and well-maintained.</p>
					</div>
				</div>
			</div>
		),
		"Roof Cleaning": (
			<div className={styles.service_content}>
				<p className={`m2 inter light ${styles.service_content_subheading}`}>Mylo is a leading provider of professional roof cleaning services across Australia. With a team of skilled technicians and state-of-the-art equipment, we specialise in restoring the appearance and extending the lifespan of roofs for homes, businesses, and organisations. Our comprehensive cleaning solutions ensure your roof remains clean, safe, and well-maintained year-round.</p>
				<p className={`m2 inter light`}>At Mylo, we offer a wide range of roof cleaning services tailored to meet the unique needs of each client. Our environmentally friendly approach uses non-toxic, biodegradable products that are safe for your home, your family, and the environment. Our services include:</p>

				<div className={styles.service_arrow_list}>
					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Roof Inspection: Before any cleaning begins, our experienced technicians conduct a detailed roof inspection to assess its condition. This helps us identify any issues and determine the most appropriate cleaning method based on the roof's material, age, and specific requirements.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Soft Wash Roof Cleaning: For delicate or older roofs, we use a gentle soft wash technique. This low-pressure method, combined with eco-friendly cleaning solutions, effectively removes dirt, moss, algae, lichen, and stains—without damaging the roof surface.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Pressure Washing: For more robust roofing materials such as metal, concrete tiles, or asphalt shingles, we offer high-pressure washing. This method delivers a deep clean, removing stubborn stains and build-up, and restoring the roof’s original appearance.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Gutter Cleaning: Clean gutters are essential to maintaining the health of your roof and preventing water damage. Our team removes debris, leaves, and blockages to ensure proper drainage and protect your property from overflow and structural damage.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Roof Maintenance: Beyond cleaning, we provide preventative maintenance services to help extend your roof’s lifespan. This includes minor repairs, replacing missing tiles or shingles, and applying protective coatings to enhance durability and resistance to future damage.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Safety Measures: The safety of your property, your family, and our team is our top priority. We strictly follow safety protocols and use industry-standard equipment to ensure every project is completed safely and efficiently.</p>
					</div>
				</div>
			</div>
		),
		"Gutter Cleaning": (
			<div className={styles.service_content}>
				<p className={`m2 inter light ${styles.service_content_subheading}`}>Mylo is a trusted name in gutter cleaning across Australia, known for delivering top-tier services that protect your property and enhance its longevity. With a team of skilled, experienced technicians, we’re committed to keeping your gutters clean, clear, and fully functional year-round.</p>
				<p className={`m2 inter light`}>At Mylo, we specialise in a full range of gutter maintenance solutions designed to keep your property safe from water damage. Our services include:</p>

				<div className={styles.service_arrow_list}>
					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Gutter Cleaning: We thoroughly remove leaves, debris, and blockages from your gutters to restore proper water flow and prevent overflow, leaks, or damage to your roof, walls, and foundation.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Gutter Guard Installation: To reduce the frequency of cleaning and prevent future clogs, we offer professional installation of gutter guards. These guards block leaves and debris while allowing water to pass through freely—keeping your gutters functional for longer.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Downpipes Cleaning: Blocked downpipes can cause significant water damage if left unchecked. Our technicians ensure that downpipes are clear and flowing correctly as part of our comprehensive gutter maintenance service.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Roof & Fascia Cleaning: We go beyond gutter cleaning by also clearing dirt, mould, and debris from your roofline and fascia. This not only enhances the appearance of your property but also supports the overall effectiveness of your gutter system.</p>
					</div>
				</div>

				<p className={`m2 inter light ${styles.service_content_subheading}`}>Why Mylo Should be your top choice:</p>
				<div className={styles.service_arrow_list}>
					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Professional & Experienced Technicians: Our team consists of highly trained professionals with years of hands-on experience in gutter care. No matter the size or condition of your system, we bring precision, safety, and care to every job.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>High-Quality Service: We use industry-standard tools and proven techniques to ensure your gutter system functions at its best. Quality and attention to detail are at the core of everything we do.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Competitive Pricing: We believe in offering exceptional value. Our pricing is transparent and competitive, with no compromise on service quality.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Reliable & Efficient: We respect your time. Our team arrives promptly, works efficiently, and leaves your property clean—with minimal disruption to your routine.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Customer Satisfaction: Your satisfaction is our top priority. We pride ourselves on delivering a seamless customer experience from start to finish, with friendly service and dependable results.</p>
					</div>
				</div>
			</div>
		),
		"Garage Doors": (
			<div className={styles.service_content}>
				<p className={`m2 inter light ${styles.service_content_subheading}`}>Mylo Services is a trusted and reputable provider of garage door services across Australia. With a skilled team of technicians and a strong commitment to customer satisfaction, we offer a full range of garage door solutions for homeowners, businesses, and organisations. Whether you need installation, repairs, or routine maintenance, we’re here to ensure your garage doors are functional, secure, and safe.</p>
				<p className={`m2 inter light`}>At Mylo Services, we tailor our services to meet the specific needs of our clients. Our offerings include:</p>

				<div className={styles.service_arrow_list}>
					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Garage Door Installation: If you’re in need of a new garage door, our experienced technicians can manage the complete installation process. We offer a wide selection of styles including sectional doors, roller doors, and tilt doors—designed to suit your budget, aesthetic preferences, and security requirements. We ensure your new door is installed correctly for smooth operation and long-term durability.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Garage Door Repairs: Garage door not working properly? Whether it’s a broken spring, faulty opener, snapped cable, or sensor issue, our team can quickly diagnose and fix the problem. We focus on fast, effective repairs to restore the performance and safety of your garage door with minimal disruption.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Garage Door Maintenance: Regular maintenance is key to keeping your garage door operating smoothly and avoiding unexpected breakdowns. Our maintenance service includes lubrication, spring and cable adjustments, inspection of tracks and hardware, and testing of safety mechanisms. Routine servicing helps extend the life of your garage door and reduces the likelihood of costly future repairs.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Garage Door Remote & Opener Services: Having trouble with your garage door remote or opener? Our technicians are experienced in troubleshooting and repairing common issues such as wiring faults, signal interference, or worn components. We also offer installation of new remotes and can upgrade your system to a modern, more convenient opener solution.</p>
					</div>
				</div>
			</div>
		),
		"Locksmith": (
			<div className={styles.service_content}>
				<p className={`m2 inter light ${styles.service_content_subheading}`}>Mylo is a trusted provider of locksmith solutions across Australia. With a team of certified and highly skilled professionals, we deliver a wide range of services for homeowners, businesses, and organisations. Whether you need emergency assistance, key duplication, or advanced security system installations, we are committed to protecting your property with reliable, efficient, and professional service.</p>
				<p className={`m2 inter light`}>At Mylo, we offer a comprehensive suite of locksmith services tailored to meet the unique needs of our clients. Our offerings include:</p>

				<div className={styles.service_arrow_list}>
					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Emergency Lockout Services: Locked out of your home, office, or vehicle? Our technicians are available to respond quickly and get you back inside safely. We can also provide on-the-spot key duplication or rekeying if required.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Lock Installation & Repair: We install and repair a wide variety of locks to suit your security requirements, including deadbolts, knob locks, lever handle locks, and mortise locks. Whether you’re upgrading security or repairing damaged hardware, we ensure every job is completed with precision and care.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Key Duplication: We offer fast, accurate key duplication services for all types of keys—including house keys, car keys, padlock keys, and restricted keys. Using advanced key-cutting equipment, we guarantee smooth operation and a perfect fit every time.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Master Key Systems: Enhance your property’s access control with a customised master key system. Ideal for businesses, strata properties, and multi-access facilities, these systems allow varying levels of access for different users while streamlining key management.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Security System Installation & Maintenance: We also specialise in the installation and servicing of modern security systems, including CCTV cameras, alarm systems, and access control solutions. Our team will assess your property and recommend a system that fits your needs, ensuring everything operates smoothly and securely over time.</p>
					</div>
				</div>
			</div>
		),
		"Rubbish Removal": (
			<div className={styles.service_content}>
				<p className={`m2 inter light ${styles.service_content_subheading}`}>Mylo is a trusted provider of rubbish removal solutions across Australia. With a team of reliable professionals and a strong commitment to sustainable waste management, we support both residential and commercial clients in disposing of their waste safely, efficiently, and responsibly. Our mission is to deliver affordable, eco-friendly rubbish removal services that contribute to a cleaner and greener environment.</p>
				<p className={`m2 inter light`}>At Mylo, we offer a comprehensive range of rubbish removal options tailored to suit the diverse needs of our clients. Our services include:</p>

				<div className={styles.service_arrow_list}>
					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>General Rubbish Removal: Whether it’s household clutter or office clean outs, we handle the removal of unwanted items like furniture, appliances, and miscellaneous junk. Our experienced team ensures all waste is collected and disposed of responsibly.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Green Waste Removal: From branches and leaves to grass clippings, we collect garden waste and ensure it is composted or recycled for maximum environmental benefit.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Electronic Waste (E-Waste) Removal: We specialise in the safe collection and recycling of electronic waste. Our eco-conscious process ensures that harmful components are handled appropriately, minimising their impact on the environment.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Construction Waste Removal: Construction and renovation projects can produce significant debris. Our team is equipped to manage and remove materials such as timber, bricks, concrete, and other building waste quickly and efficiently.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Commercial & Industrial Waste Removal: We provide tailored rubbish removal solutions for commercial and industrial sites. Our team understands the unique demands of these environments and delivers prompt, professional service to meet your operational needs.</p>
					</div>
				</div>
			</div>
		),
		"Pest Control": (
			<div className={styles.service_content}>
				<p className={`m2 inter light ${styles.service_content_subheading}`}>Mylo is a trusted provider of professional pest control solutions across Australia. With a team of skilled technicians and a commitment to effective pest management, we help residential and commercial clients eliminate and prevent pest infestations. Our goal is to create safe, pest-free environments that protect our clients’ health, property, and peace of mind.</p>
				<p className={`m2 inter light`}>At Mylo, we offer a comprehensive range of pest control services designed to tackle various pest challenges. Our offerings include:</p>

				<div className={styles.service_arrow_list}>
					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>General Pest Control: We target common household pests such as ants, spiders, cockroaches, silverfish, and bed bugs. Our experienced technicians assess the severity of the infestation and develop tailored treatment plans to effectively eliminate pests from your home or business.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Rodent Control: Rodents can cause structural damage and spread disease. Our rodent control services include detailed inspections, baiting, trapping, and exclusion techniques to remove rats and mice and prevent future infestations.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Termite Control: Termites pose a serious threat to properties if left untreated. Our specialists use advanced detection tools and environmentally responsible treatments to eliminate termites and protect your building from long-term damage.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Mosquito & Fly Control: Mosquitoes and flies are not only annoying but also potential carriers of disease. We identify breeding areas, apply targeted treatments, and provide practical recommendations to reduce their presence and prevent future outbreaks.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Wildlife Management: For wildlife intrusions involving possums, birds, snakes, or other animals, we offer humane and ethical removal services. Our team ensures safe relocation and implements preventative measures to deter future entry.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Commercial Pest Control: We provide customised pest control solutions for commercial properties including restaurants, hotels, offices, and retail spaces. Understanding the importance of maintaining a clean and compliant environment, we work closely with business owners to develop effective, ongoing pest management plans.</p>
					</div>
				</div>
			</div>
		),
		"Gardening": (
			<div className={styles.service_content}>
				<p className={`m2 inter light ${styles.service_content_subheading}`}>Mylo is a reputable provider of professional gardening services across Australia. With a passion for creating and maintaining beautiful outdoor spaces, our team of skilled and experienced gardeners is committed to delivering exceptional service to both residential and commercial clients. Whether you need regular garden maintenance, landscaping, or garden design, we have the expertise to transform your outdoor area into a stunning and functional oasis.</p>
				<p className={`m2 inter light`}>At Mylo, we offer a comprehensive range of gardening services tailored to meet the diverse needs of our clients. Our services include:</p>

				<div className={styles.service_arrow_list}>
					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Garden Maintenance: Our expert gardeners handle all aspects of regular garden upkeep, including mowing, trimming, pruning, weeding, and fertilising. We’ll keep your garden healthy, vibrant, and looking its best year-round.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Landscape Design & Installation: Ready to reimagine your outdoor space? Our landscape designers work closely with you to develop functional and visually appealing layouts. From plant selection and softscaping to hardscapes and water features, we bring your vision to life with precision and creativity.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Irrigation Systems: A well-designed irrigation system is key to a thriving garden. We design and install efficient, water-smart systems customised to your garden’s needs, ensuring optimal plant health and minimising water waste.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Garden Clean-Up: If your garden is overgrown or neglected, we offer thorough clean-up services. Our team will clear out weeds, debris, and unwanted vegetation, leaving your space neat, refreshed, and ready to enjoy.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Tree & Hedge Services: Our qualified arborists provide professional tree and hedge care, including pruning, trimming, tree removal, and stump grinding. We follow industry best practices to maintain the safety, health, and appearance of your trees and hedges.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Pest & Disease Management: Protect your garden from harmful pests and plant diseases with our environmentally friendly treatment solutions. Our team understands the unique challenges of Australian gardens and applies safe, effective methods to restore and maintain plant health.</p>
					</div>
				</div>
			</div>
		),
		"Fence Painting": (
			<div className={styles.service_content}>
				<p className={`m2 inter light ${styles.service_content_subheading}`}>Welcome to Mylo — your trusted partner for professional fence painting services across Australia. We take pride in delivering exceptional results, using premium materials and expert craftsmanship to transform tired fences into standout features. With a strong focus on customer satisfaction, our experienced team is here to enhance the beauty, value, and curb appeal of your property.</p>
				<p className={`m2 inter light`}>Don't let a weathered or outdated fence bring down the look of your property. At Mylo, we help you turn your fence into a standout feature that enhances your home’s exterior and adds long-term value. With our industry expertise, high-quality materials, and reliable service — all at competitive prices — we’re proud to be a top choice for fence painting across Australia. Contact us today and experience the Mylo difference: a beautifully painted fence that impresses for years to come.</p>

				<p className={`m2 inter light ${styles.service_content_subheading}`}>Why Mylo Should be your top choice:</p>
				<div className={styles.service_arrow_list}>
					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Expertise & Experience: Our skilled team brings years of hands-on experience across all types of fencing, including timber, Colorbond, and other materials. We understand that each fence requires a tailored approach, and we’re committed to delivering flawless, long-lasting results.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Premium Materials: We use only top-quality paints, coatings, and protective finishes to ensure maximum durability and aesthetic appeal. Our careful material selection means your newly painted fence will look great and stand up to the elements for years to come.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Professional & Reliable Service: From consultation to completion, we deliver a smooth and efficient service. Our team respects your time and property, working with professionalism, punctuality, and a keen eye for detail. You can count on us to get the job done right — the first time.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Customised Style Options: Your fence should reflect your personal style. Whether you're after a classic neutral palette or a bold, modern statement, we offer a wide selection of colours and finishes to match your vision. We’ll work with you to create a custom solution that complements your home and garden.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Transparent & Competitive Pricing: Quality doesn’t have to come at a premium. Our pricing is competitive, fair, and fully transparent — with no hidden costs. We provide detailed quotes upfront, so you know exactly what to expect and can feel confident in your investment.</p>
					</div>
				</div>
			</div>
		),
		"EV Charging Install": (
			<div className={styles.service_content}>
				<p className={`m2 inter light ${styles.service_content_subheading}`}>MYLO is a trusted provider of EV charging station installation services in Australia. With a team of experienced and qualified electricians and a commitment to a sustainable transportation solution, we help EV owners, businesses, and organisations install efficient and reliable charging infrastructure. Our goal is to promote the adoption of EV's and contribute to a cleaner and greener future.</p>

				<div className={styles.service_arrow_list}>
					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Home EV Charging Station Installation: If you own an electric vehicle and want to install a charging station at home, we can help! Our team of experienced electricans will assess your electrical system, recommend the best charging station solution, and install it to ensure efficient and reliable charging.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Commercial EV Charging Station Installation: We also offer EV charging station installations for businesses and organisations. Whether you are looking to provide charging stations for your employees or customers, our team can design and install a customised charging infrastructure that meets your needs.</p>
					</div>

					<div className={styles.service_arrow_item}>
						<i className="fa-thin fa-arrow-right m2"></i>
						<p className={`m2 inter light`}>Public EV Charging Installation: As EV adoption continues to grow, public EV charging infrastructure is becoming increasingly important. We can help cities, municipalities, and organisations install public EV charging stations in convenient locations.</p>
					</div>
				</div>
			</div>
		)
	}

	return (
		<div className={styles.services_container}>
			<div className={styles.inner_services}>
				<div className={styles.services_catheaders}>
					<p className={`xxxxl3 forma bold`}><span>Tradies</span> Services</p>
					<i className={`fa-thin fa-arrow-right xxxl3 ${styles.non_optimised}`}></i>

					<i className={`fa-solid fa-shield-check xxxxl3 ${styles.safety_icon} ${styles.non_optimised}`}></i>
				</div>

				<p className={`m2 inter light ${styles.services_catsubheader}`}>Mylo Tradies offers a large variety of property services tailored to your needs. Our staff are committed to providing you with outstanding service to the highest standards because for us, its simple.</p>

				<div className={styles.service_inner}>
					<div className={styles.services_overview_split}>
						<div className={styles.services_overview_primary}>
							<div className={styles.services_overview_item}>
								{Object.keys(services).map((serv, i) => (
									<button onClick={() => setActiveService(serv)}><p className={`l3 inter bold ${activeService === serv && styles.services_overview_active}`}>{serv}</p></button>
								))}
							</div>

							<div className={styles.non_optimised} style={{ display: 'flex', flexDirection: 'column', rowGap: '2rem' }}>
								<div className={`${styles.contactus_box}`}>
									<i className="fa-solid fa-phone xxl3"></i>
									<p className={`xl3 forma bold ${styles.cmessage_banner}`}>Talk to a member of our Sales team</p>
									<p className={`m2 inter light`}>We'll help you find the right services and pricing for your home or business</p>

									<a className={styles.contactus_box_btn} href={"tel:+136956"}>
										<p className={`m3 inter medium`}>Call MYLO</p>
									</a>
								</div>

								<HouseTransition/>
							</div>
						</div>
						
						<div className={styles.services_overview_secondary}>
							<div className={styles.services_overview_img}>
								<img src={smoke_alarm}/>
							</div>

							<div className={styles.service_bottom_btns}>
								<div className={styles.service_bottom_btns_circle}><i className="fa-thin fa-arrow-left xl3"></i></div>
								<div className={styles.service_bottom_btns_circle}><i className="fa-thin fa-arrow-right xl3"></i></div>
							</div>

							<div className={styles.service_content_list}>
								<div className={styles.service_content_heading}>
									<p className={`xxl3 forma medium`}>{activeService}</p>
								</div>

								{services[activeService]}

								<button className={`${styles.service_bottom_btns_btn}`}>
									<p className={`l1 inter medium`}>Book a Service Now</p>
									<i className="fa-solid fa-box-open l2"></i>
								</button>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	)
}

const HowItWorks = () => {
	const [collapsed, setCollapsed] = useState([0])
	const data = {
		"Choose your Package": {
			text: "Use our online service calculator to select the right safety package for your property",
			button: null
		},
		"Sign Up": {
			text: "Complete our digital service agreement form, providing key property details so we can begin the process of making your home safe and compliant",
			button: null
		},
		"Confirmation": {
			text: "We will confirm all details with either yourself directly or your property manager - depending on your preference",
			button: null
		},
		"Invoicing": {
			text: "You’ll receive an invoice based on your selected package. Options include annual, upfront, or monthly billing. We're happy to discuss flexible arrangements to suit your needs, so don’t hesitate to contact us for more information and ways we can assist you",
			button: null
		},
		"Scheduling": {
			text: "Our expert bookings and logistics team will ensure your property is scheduled with the appropriate stakeholder. Whether it be a vacant property or arranging a suitable time with your tenants, we will always strive to make the process as seamless as possible",
			button: null
		},
		"Reports": {
			text: "Our licensed technicians conduct the checks and submit their findings, which are reviewed by our technical advisors before generating reports and, if needed, follow-up quotes",
			button: null
		},
		"Completion": {
			text: "Once processed, reports and any quotes are sent to you and/or your property manager via our secure client portal",
			button: null
		},
		"Follow Up & Ongoing Reminders": {
			text: "We’ll notify you ahead of your next scheduled inspection, confirm your preferences, and keep your property on track with compliance",
			button: null
		}
	}

	const handleCollapse = (key) => {
		if (collapsed.includes(key)) {
			setCollapsed((prev) => ([...prev].filter(k => k !== key)))
		} else {
			setCollapsed((prev) => ([...prev, key]))
		}
	}

	return (
		<div className={styles.howitworks_container}>
			<div className={styles.transition_container} style={{ top: '-80px' }}>
				<div className={styles.transition_effect_1} style={{ top: '50px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#f56329" }}/>
				<div className={styles.transition_effect_2} style={{ top: '20px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#f56329" }}/>
				<div className={styles.transition_effect_3} style={{ top: '-10px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#f56329" }}/>
			</div>

			<div className={styles.howitworks_inner_container}>
				<div className={styles.howitworks_heading}>
					<p className={`xxxxl3 forma bold`}>How it Works</p>
					<i className={`fa-thin fa-arrow-right xxxl3 ${styles.non_optimised}`}></i>

					<i className={`fa-solid fa-gear xxxxl3 ${styles.howitworks_icon}`}></i>
				</div>

				<p className={`xxl3 forma medium ${styles.howitworks_subheading_main}`}>Booking a service with MYLO is very easy.</p>
				<p className={`m2 inter light ${styles.howitworks_subheading}`}>Simply follow the steps below and before you know it, we'll have a specialised MYLO consultant, tradesperson or assessor booked in to begin modifying your home to suit your needs.</p>

				<div className={styles.steps_container}>
					{Object.keys(data).map((key, index) => {
						const isCollapsed = collapsed.includes(key)
						const text = data[key].text
						const btn = data[key].btn

						return (
							<button className={`${styles.step_container} ${isCollapsed && styles.step_container_full}`} onClick={() => handleCollapse(key)}>
								<div className={`${styles.step_heading} ${styles.non_optimised}`}>
									<div className={styles.step_ticker}><p className={`l2 inter medium`}>Step {index+1}</p></div>
									<p className={`xl1 inter medium`}>{key}</p>

									<i className={`fa-thin fa-${isCollapsed ? "minus" : "plus"} xxxxl3`}></i>
								</div>

								<div className={`${styles.step_heading} ${styles.optimised}`}>
									<div className={styles.step_ticker}><p className={`l2 inter medium`}>{index+1}</p></div>
									<p className={`xl1 inter medium`}>{key}</p>

									<i className={`fa-thin fa-${isCollapsed ? "minus" : "plus"} xxxxl3`}></i>
								</div>

								{isCollapsed &&
									<div className={styles.step_content}>
										<p className={`m2 inter light`}>{text}</p>

										{btn &&
											<button className={styles.step_content_button}>
												<p className={`m2 inter medium`}>Create a MYLO Account</p>
												<i className="fa-thin fa-arrow-right m3"></i>
											</button>
										}
									</div>
								}
							</button>
						)
					})}
				</div>

				<div className={styles.howitworks_help}>
					<p className={`xxl3 forma medium ${styles.howitworks_subheading_main}`}>Got Questions...? No Problems.</p>
					<p className={`m2 inter light ${styles.howitworks_help_text}`}>Call 13MYLO 24/7 or connect via our helpdesk to talk to one of our specialised consultants<br/>about how we can support you in creating a home environment to suit all your needs.</p>

					<a className={styles.howitworks_help_button} href={"tel:+136956"}>
						<p className={`m2 inter medium`}>Call 13MYLO</p>
						<i className="fa-solid fa-phone m3"></i>
					</a>
				</div>
			</div>
		</div>
	)
}


const HouseBanner = () => {
  	const refs = {
    	car1: useRef(null),
    	car2: useRef(null),
    	cloud1: useRef(null),
    	cloud2: useRef(null),
    	cloud3: useRef(null),

    	car1opt: useRef(null),
    	cloud1opt: useRef(null)
  	};

  	const config = [
    	{ key: "car1", speed: 0.3, dir: 1 },
    	{ key: "car2", speed: 0.3, dir: -1 },
    	{ key: "cloud1", speed: 0.2, dir: 1 },
    	{ key: "cloud2", speed: 0.2, dir: -1 },
    	{ key: "cloud3", speed: 0.2, dir: -1 },

    	{ key: "car1opt", speed: 0.025, dir: 1 },
    	{ key: "cloud1opt", speed: 0.025, dir: -1 }
  	];

  	const targetXs = useRef(config.map(() => 0));
  	const currentXs = useRef(config.map(() => 0));

  	useEffect(() => {
    	const handleScroll = () => {
      		const y = window.scrollY;
      		config.forEach((c, i) => {
        		targetXs.current[i] = y * c.speed;
      		});
    	};

    	window.addEventListener("scroll", handleScroll, { passive: true });

    	let rafId;
    	const animate = () => {
      		config.forEach((c, i) => {
        		const el = refs[c.key].current;
        		if (!el) return;
        		currentXs.current[i] += (targetXs.current[i] - currentXs.current[i]) * 0.1;
        		el.style.transform = `translateX(${currentXs.current[i] * c.dir}px)`;
      		});

      		rafId = requestAnimationFrame(animate);
    	};

    	rafId = requestAnimationFrame(animate);

    	return () => {
      		window.removeEventListener("scroll", handleScroll);
      		cancelAnimationFrame(rafId);
    	};
  	}, []);


	return (
		<div className={styles.house_banner_container}>
			<img src={mylo_home_banner} className={`${styles.car_banner} ${styles.non_optimised}`}/>
			<img src={car1} className={`${styles.car1} ${styles.non_optimised}`} ref={refs.car1}/>
			<img src={car2} className={`${styles.car2} ${styles.non_optimised}`} ref={refs.car2}/>
			<img src={cloud1} className={`${styles.cloud1} ${styles.non_optimised}`} ref={refs.cloud1}/>
			<img src={cloud2} className={`${styles.cloud2} ${styles.non_optimised}`} ref={refs.cloud2}/>
			<img src={cloud3} className={`${styles.cloud3} ${styles.non_optimised}`} ref={refs.cloud3}/>

			<img src={mylo_home_banner_short} className={`${styles.car_banner} ${styles.optimised}`}/>
			<img src={car1} className={`${styles.car1opt} ${styles.optimised}`} ref={refs.car1opt}/>
			<img src={cloud1} className={`${styles.cloud1opt} ${styles.optimised}`} ref={refs.cloud1opt}/>
		</div>
	)
}

const Packages = () => {
	const [activeTerms, setActiveTerms] = useState("Annually")
	const pricing = {
		"Weekly": {
			"MYLO Silver": 7,
			"MYLO Gold": 9
		},
		"Annually": {
			"MYLO Silver": 290,
			"MYLO Gold": 399
		}
	}

	return (
		<div className={styles.packages_container} id="packages">
			<div className={styles.transition_container} style={{ top: '0', height: '90px', backgroundColor: "black" }}>
				<div className={styles.transition_effect_1} style={{ top: '0', background: "#f56329", height: '30px' }}/>
				<div className={styles.transition_effect_2} style={{ top: '30px', background: "#f56329", height: '30px' }}/>
				<div className={styles.transition_effect_3} style={{ bottom: '0', background: "#f56329", height: '30px' }}/>
			</div>


			<div className={styles.packages_inner_container}>
				<HouseTransition/>

				<div className={styles.packages_heading}>
					<i className={`fa-solid fa-box-open xxxxl3 ${styles.optimised} ${styles.howitworks_icon}`}></i>
					<p className={`xxxxl3 forma bold`}>Safety Packages</p>
					<i className={`fa-thin fa-arrow-right xxxl3 ${styles.non_optimised}`}></i>

					<i className={`fa-solid fa-box-open xxxxl3 ${styles.howitworks_icon} ${styles.non_optimised}`}></i>
				</div>

				<p className={`xxl3 forma medium ${styles.howitworks_subheading_main}`}>Our customised services ensure that participants have safe, accessible,<br/>and well-maintained homes suited to their individual needs.</p>
				<p className={`m2 inter light ${styles.howitworks_subheading}`}>Every property is different, which is why MYLO offers a range of package options tailored to your needs. Whether you’re after a one-off compliance check, a monthly or annual subscription, or a customised structure to suit your portfolio, we’re here to help you protect your property with ease and confidence.<br/><br/>All subscription models come with a two-year minimum commitment, ensuring long-term value and consistent compliance coverage.<br/><br/>How are we able to keep the pricing low and consistent? Our unique subscription model is unlike anything else on the market. By strategically structuring inspections across a two-year cycle, we’re able to offer year-round service at a consistently low cost—without compromising on quality or coverage.<br/><br/>To ensure your property remains safe and fully compliant, we follow a structured inspection process:<br/><br/>Year 1: A full compliance check covering Gas, Electrical, and Smoke Alarms.<br/>Year 2 onwards:</p>
				<ul className={styles.howitworks_ul}>
					<li><p className={`m2 inter light`}>Annual Smoke Alarm Inspections (as required by law)</p></li>
					<li><p className={`m2 inter light`}>Gas and Electrical Inspections alternating each year—one year a licensed gas fitter will conduct the gas safety check, and the next year an electrician will conduct the electrical inspection.</p></li>
					<li><p className={`m2 inter light`}>We cover the additional inspection costs in the first cycle to establish this rhythm, enabling a more efficient, affordable system moving forward.</p></li>
				</ul>

				<HouseBanner/>

				<div className={styles.package_list_container}>
					<div className={styles.package_list_header}>
						<p className={`xl3 forma medium ${styles.package_list_heading}`}>Some of our convenient Safety Packages are here</p>

						<a className={styles.package_list_button} href={"tel:+136956"}>
							<p className={`m2 inter medium`}>Call us to discuss which<br/>package is right for you</p>
							<i className="fa-solid fa-phone l3"></i>
						</a>
					</div>

					<div className={styles.package_controls}>
						<button className={`${styles.package_control} ${activeTerms === "Weekly" && styles.package_control_active}`} onClick={() => setActiveTerms("Weekly")}>
							<p className={`m2 inter medium`}>Weekly</p>
						</button>

						<button className={`${styles.package_control} ${activeTerms === "Annually" && styles.package_control_active}`} onClick={() => setActiveTerms("Annually")}>
							<p className={`m2 inter medium`}>Annually</p>
						</button>
					</div>

					<div className={styles.package_list}>
						<div className={styles.package_item}>
							<div className={styles.package_item_heading}>
								<div className={`${styles.package_item_heading_r1} ${styles.non_optimised}`}>
									<p className={`xxl1 forma bold ${styles.package_list_heading}`}>${pricing[activeTerms]["MYLO Silver"]} {activeTerms === "Weekly" ? "per week" : "annually"}</p>	
								</div>
								<div className={`${styles.package_item_heading_r2} ${styles.non_optimised}`}/>
								<div className={`${styles.package_item_heading_r3} ${styles.non_optimised}`}/>

								<i className="fa-solid fa-award xl1"></i>
								<div>
									<p className={`l3 forma bold ${styles.package_list_heading}`}>MYLO Silver</p>
									<p className={`l3 forma bold ${styles.package_list_heading} ${styles.optimised}`}>${pricing[activeTerms]["MYLO Silver"]} {activeTerms === "Weekly" ? "per week" : "annually"}</p>
								</div>
							</div>

							<div className={styles.services_include_container}>
								<p className={`l2 forma medium ${styles.package_list_heading}`}>Services Include:</p>

								<ul>
									<li><p className={`m3 inter light`}>Full Electrical Compliance Check</p></li>
									<li><p className={`m3 inter light`}>Full Gas Compliance Check - (all gas appliances inclusive)</p></li>
									<li><p className={`m3 inter light`}>Annual Smoke Alarms Check</p></li>
									<li><p className={`m3 inter light`}>Priority Emergency Response</p></li>
									<li><p className={`m3 inter light`}>Unlimited Smoke Alarms Callout</p></li>
									<li><p className={`m3 inter light`}>Advanced Management Portal</p></li>
									<li><p className={`m3 inter light`}>Comprehensive Compliance Reports</p></li>
									<li><p className={`m3 inter light`}>MYLO Multi-Qualified Technicians</p></li>
									<li><p className={`m3 inter light`}>Flexible Payment Structure</p></li>
								</ul>
							</div>
						</div>

						<div className={styles.package_item}>
							<div className={styles.package_item_heading}>
								<div className={`${styles.package_item_heading_r1} ${styles.non_optimised}`}>
									<p className={`xxl1 forma bold ${styles.package_list_heading}`}>${pricing[activeTerms]["MYLO Gold"]} {activeTerms === "Weekly" ? "per week" : "annually"}</p>
								</div>
								<div className={`${styles.package_item_heading_r2} ${styles.non_optimised}`}/>
								<div className={`${styles.package_item_heading_r3} ${styles.non_optimised}`}/>

								<i className="fa-solid fa-award xl1"></i>
								<div>
									<p className={`l3 forma bold ${styles.package_list_heading}`}>MYLO Gold</p>
									<p className={`l3 forma bold ${styles.package_list_heading} ${styles.optimised}`}>${pricing[activeTerms]["MYLO Gold"]} {activeTerms === "Weekly" ? "per week" : "annually"}</p>
								</div>
							</div>

							<div className={styles.services_include_container}>
								<p className={`l2 forma medium ${styles.package_list_heading}`}>Services Include:</p>

								<ul>
									<li><p className={`m3 inter light`}>Full Electrical Compliance Check</p></li>
									<li><p className={`m3 inter light`}>Full Gas Compliance Check - (all gas appliances inclusive)</p></li>
									<li><p className={`m3 inter light`}>Annual Smoke Alarms Check</p></li>
									<li><p className={`m3 inter light`}>Minimum Standards Report</p></li>
									<li><p className={`m3 inter light`}>Unlimited Smoke Alarms Callout</p></li>
									<li><p className={`m3 inter light`}>Unlimited Handyman Callout</p></li>
									<li><p className={`m3 inter light`}>Unlimited Electrical Callout</p></li>
									<li><p className={`m3 inter light`}>Unlimited Plumber Callout</p></li>
									<li><p className={`m3 inter light`}>Free Emergency Locksmith Callouts</p></li>
									<li><p className={`m3 inter light`}>Advanced Management Portal</p></li>
									<li><p className={`m3 inter light`}>MYLO Multi-Qualified Technicians</p></li>
									<li><p className={`m3 inter light`}>Flexible Payment Structure</p></li>
									<li><p className={`m3 inter light`}>Priority Emergency Response</p></li>
									<li><p className={`m3 inter light`}>Comprehensive Compliance Reports</p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}



const Calculator = () => {
	return (
		<div className={styles.calculator_container}>
			<div className={styles.inner_calculator}>
				<div className={styles.calculator_catheaders}>
					<p className={`xxxxl3 forma bold`}><span>Safety</span> Calculator</p>
					<i className={`fa-thin fa-arrow-right xxxl3 ${styles.non_optimised}`}></i>

					<i className={`fa-solid fa-calculator xxxxl3 ${styles.safety_icon} ${styles.non_optimised}`}></i>
				</div>

				<p className={`xxl3 forma medium ${styles.calculator_subheading_main}`}>Use our easy to use pricing calculator to see how much it<br/>would cost to ensure your home stays safe all year round.</p>
				<p className={`m2 inter light ${styles.calculator_catsubheader}`}>Take the hassle out of pricing your products with this free service pricing calculator. Our trusted pricing formula will help you find a fair price for your services, so you can sit back & relax knowing all your home safety services are taken care of by reliable, trusted technicians.</p>
				
				<div className={styles.calculator_inner}>
					<div className={styles.calculator_box_main}>
						<p className={`l1 forma medium`}>Payment Terms:</p>
						<div className={styles.calculator_button_container}>
							<button className={`${styles.calculator_button} ${styles.calculator_button_active}`}>
								<p className={`m3 inter medium`}>Yearly</p>
							</button>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>Monthly</p>
							</button>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>One-Off</p>
							</button>
						</div>

						<p className={`l1 forma medium ${styles.calculator_btnheading}`}>Subscription:</p>
						<div className={styles.calculator_button_container}>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>Gold</p>
							</button>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>Silver</p>
							</button>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>No Package</p>
							</button>
						</div>

						<p className={`l1 forma medium ${styles.calculator_btnheading}`}>Services:</p>
						<div className={styles.calculator_button_container}>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>Gas</p>
							</button>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>Smoke</p>
							</button>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>Electrical</p>
							</button>
							<button className={styles.calculator_button}>
								<p className={`m3 inter medium`}>Rental Minimum Standards</p>
							</button>
						</div>

						<div className={styles.heading_bottom}>
							<p className={`m2 inter light`}>Every property is different, which is why MYLO offers a range of package options tailored to your needs. Whether you’re after a one-off compliance check, a monthly or annual subscription, or a customised structure to suit your portfolio, we’re here to help you protect your property with ease and confidence.</p>
							<p className={`m3 inter bold ${styles.red_heading}`}>For more info, call us on 13 MYLO (13 69 56) today</p>
						</div>
					</div>

					<div className={styles.calculator_box_services}>
						<p className={`xl1 forma medium ${styles.calculator_priceheading}`}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut semper metus sed nunc tincidunt ac cumsan. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut semper metus sed nunc tincidunt ac cumsan.</p>

						<div className={styles.calculator_circle}><i className={`fa-thin fa-arrow-down xl1`}></i></div>

						<div className={styles.calculator_price_banner}>
							<p className={`xl1 inter bold`}>$340 +GST</p>
						</div>
					</div>
					
					<div className={styles.calculator_box_price}>
						<p className={`xl1 forma medium ${styles.calculator_priceheading}`}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut semper metus sed nunc tincidunt ac cumsan. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut semper metus sed nunc tincidunt ac cumsan.</p>

						<div className={styles.calculator_circle}><i className={`fa-thin fa-arrow-down xl1`}></i></div>

						<div className={styles.calculator_price_banner}>
							<p className={`xl1 inter bold`}>$340 +GST</p>
						</div>
					</div>

				</div>
			</div>
		</div>
	)
}



const FrequentlyAskedQuestions = () => {
	const [collapsed, setCollapsed] = useState(0)
	const questions = [
		{
			question: "What range of services does MYLO Services provide?",
			answer: "MYLO offers a comprehensive suite of property and maintenance solutions, including EV charging station installation, roof cleaning, garage door services, plumbing, electrical work, handyman tasks, locksmith services, gutter cleaning, rubbish removal, pest control, gardening, fence painting, accessibility equipment installation, and home modifications."
		},
		{
			question: "Do you cater to both residential and commercial clients?",
			answer: "Yes—our services are available for both homes and businesses across all categories, ensuring tailored solutions for residential and commercial properties alike."
		},
		{
			question: "What qualifications and experience do your technicians have?",
			answer: "Our team comprises fully-licensed, trained, and highly experienced professionals—electricians, plumbers, handymen, pest technicians, and more—who undergo continuous training to adhere to the latest industry standards."
		},
		{
			question: "How can I request a quote or book a service?",
			answer: "Simply call us on 13MYLO (136-956) or fill out the contact form on our website. We’ll schedule a site assessment and provide a detailed, no-obligation quote tailored to your needs."
		},
		{
			question: "What guarantees and quality standards does MYLO Services uphold?",
			answer: "We stand by transparent pricing, top-quality materials, safe and environmentally responsible methods, and prompt, reliable service—backed by our commitment to customer satisfaction on every job."
		}
	]

	return (
		<div className={styles.faq_container}>
			<div className={styles.faq_inner_container}>
				<p className={`xxxxl3 forma bold ${styles.faq_heading} ${styles.non_optimised}`}>MYLO Safety FAQ's</p>
				<p className={`xxxxl3 forma bold ${styles.faq_heading} ${styles.optimised}`}>FAQ's</p>

				<div className={styles.faq_main_container}>
					{questions.map((q, index) => (
						<button className={styles.faq_button} onClick={() => setCollapsed(index)}>
							<p className={`l3 forma medium`}>{q.question}</p>

							{collapsed === index &&
								<div className={styles.faq_content}>
									<p className={`m2 inter light`}>{q.answer}</p>
								</div>
							}

							<i className={`fa-thin fa-${collapsed === index ? "minus" : "plus"} xxxxl3`}></i>
						</button>
					))}
				</div>
			</div>

			<HouseTransition/>

			<div className={styles.transition_container} style={{ bottom: '-80px' }}>
				<div className={styles.transition_effect_1} style={{ bottom: '50px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#cacaca" }}/>
				<div className={styles.transition_effect_2} style={{ bottom: '20px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#cacaca" }}/>
				<div className={styles.transition_effect_3} style={{ bottom: '-10px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#cacaca" }}/>
			</div>
		</div>
	)
}







const Tradies = () => {
	usePageMetadata({
		title: "MYLO | Tradies",
		description: "Connect with qualified, insured tradespeople through MYLO Tradies. From plumbing and painting to carpentry and landscaping, book trusted professionals in just a few clicks."
	});

  	const containerRef = useRef(null);

  	useEffect(() => {
    	const container = containerRef.current;
    	if (!container) return;

    	const children = Array.from(container.children);
    	const observer = new IntersectionObserver((entries, obs) => {
      		entries.forEach(entry => {
        		if (entry.isIntersecting) {
          			entry.target.classList.add(styles.isVisible);
          			obs.unobserve(entry.target);
        		}
      		});
    	}, { threshold: 0.1 });

    	children.forEach(el => {
      		el.classList.add(styles.fadeInSection);
      		observer.observe(el);
    	});

    	return () => observer.disconnect();
  }, []);


	const scrollToId = (id) => {
  		const el = document.getElementById(id);
  		if (!el) return;

  		const headerOffset = 0;
  		const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
  		const offsetPosition = elementPosition - headerOffset;

  		window.scrollTo({
    		top: offsetPosition,
    		behavior: 'smooth'
  		});
	}


	return (
		<div className={styles.background} ref={containerRef}>
			<Topbar active={"Tradies"}/>
			<Banner/>
			<ServiceMessage/>
			<BannerImage/>
			<HouseTransition/>

			<Services/>
			{/* <HowItWorks/> */}
			{/* <Packages/> */}
			<FrequentlyAskedQuestions/>

			<Footer/>
		</div>
	)
};

export default Tradies;